import { Tooltip } from 'antd'
import { IconShopping } from '../../../../shared/components/icons/IconShopping'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { BadgeGroup } from '../../../../lib/ui/badge/component/badge-group/BadgeGroup'

interface AffiliateIdCellProps {
  affiliate_name?: string | null
  pub_value?: string
  affiliate: string
  tags: string[]
  has_shopping_ads?: boolean
}

export const AffiliateIdCell = ({
  affiliate_name,
  pub_value,
  affiliate,
  tags,
  has_shopping_ads,
}: AffiliateIdCellProps) => {
  const { t } = useTranslation()

  return (
    <div className='flex flex-col gap-[4px]'>
      <div className={'flex items-center gap-[8px]'}>
        <span className={'max-w-[185px] truncate whitespace-nowrap text-[15px]'}>
          {affiliate_name ?? (pub_value && pub_value.length ? pub_value : affiliate)}
        </span>
        {has_shopping_ads && (
          <Tooltip
            arrowPointAtCenter
            placement='topLeft'
            title={t('pages.paidResults.shoppingAdsTooltip')}
          >
            <div className='ml-[12px] inline-block w-[22px]'>
              <IconShopping color='#00326D' />
            </div>
          </Tooltip>
        )}
      </div>
      {(affiliate_name || pub_value) && (
        <Tooltip className='max-w-[130px] truncate text-[10px] leading-none' title={affiliate}>
          {affiliate}
        </Tooltip>
      )}
      <div className={`pt-[2px] ${!tags?.length && 'hidden'}`}>
        <BadgeGroup data={tags.map((value) => ({ value }))} />
      </div>
    </div>
  )
}
